import DataKeys from 'k8s/DataKeys'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import { imagesSelector } from 'app/plugins/openstack/components/images/selectors'

export const volumeSnapshotsSelector = createSharedSelector(
  getDataSelector<DataKeys.OpenstackVolumeSnapshots>(DataKeys.OpenstackVolumeSnapshots),
  getDataSelector<DataKeys.OpenstackVolumes>(DataKeys.OpenstackVolumes),
  imagesSelector,
  (volumeSnapshots, volumes, images) => {
    return volumeSnapshots.map((volumeSnapshot) => {
      // any model changes go here
      return {
        ...volumeSnapshot,
        created_at: `${volumeSnapshot.created_at}Z`,
        isVolumeAttached:
          volumes?.find((volume) => volume?.id === volumeSnapshot?.volume_id)?.attachments?.length >
          0,
        attachedVmSnapshot: images?.find((image) =>
          image?.snapshotIds?.includes(volumeSnapshot?.id),
        ),
      }
    })
  },
)

export const volumeSnapshotsByIdSelector = createSharedSelector(
  volumeSnapshotsSelector,
  (volumeSnapshots) => {
    return volumeSnapshots.reduce((accum, volumeSnapshot) => {
      return {
        ...accum,
        [volumeSnapshot.id]: volumeSnapshot,
      }
    }, {})
  },
)
